const OVERLAYS_CLASSES = [
  '.introjsFloatingElement',
  '.introjs-overlay',
  '.introjs-helperLayer',
  '.introjs-tooltipReferenceLayer',
];

/**
 * Moves intro-js overlays in DOM tree to different 'parent' element.
 * Used to fix problem when intro js overlays and target step element appears in different stacking context.
 * @param parentSelector
 */
const moveOverlays = (parentSelector) => {
  const overlays = document.querySelectorAll(OVERLAYS_CLASSES.join(','));
  const parent = parentSelector
    ? document.getElementById(parentSelector)
    : document.body;

  overlays.forEach((el) => {
    if (parent) parent.appendChild(el);
  });
};

export default moveOverlays;
